export const downloadDocument = async (fileUrl: string, fileName?: string, fileId?: string) => {
  if (!fileUrl) return;

  try {
    const response = await fetch(fileUrl, {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/pdf,application/octet-stream,*/*'
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to download file: ${response.status}`);
    }

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName || `document_${fileId}.pdf`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Error downloading file:', error);
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName || `document_${fileId}.pdf`;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
